import React, { useState, useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios'; // ✅ НОВОЕ: axios для запросов (как в LoginPage)
import Sidebar from './Sidebar';

// ✅ Импорт логотипа (путь поправьте под свою структуру папок)
import logo from '../../assets/logo-aksioma.png'


const Dashboard = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const [userInfo, setUserInfo] = useState(null);
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    // ✅ Состояния для модальных окон
    const [isFeedbackOpen, setIsFeedbackOpen] = useState(false);
    const [isAboutOpen, setIsAboutOpen] = useState(false);

    // ✅ Состояние формы замечаний
    const [feedback, setFeedback] = useState({
        category: 'Замечание',
        subject: '',
        message: '',
    });
    const [feedbackSent, setFeedbackSent] = useState(false);

    // ✅ НОВОЕ: состояние отправки и ошибки формы замечаний
    const [feedbackSending, setFeedbackSending] = useState(false);
    const [feedbackError, setFeedbackError] = useState('');

    const getActivePage = (pathname) => {
        if (pathname.startsWith('/reports')) return 'reports';
        if (pathname.startsWith('/map')) return 'map';
        if (pathname.startsWith('/devices')) return 'devices';
        if (pathname.startsWith('/analysis')) return 'analysis';
        if (pathname.startsWith('/admin')) return 'admin';
        if (pathname.startsWith('/ns')) return 'ns';
        if (pathname.startsWith('/mainsettings')) return 'mainsettings';
        return 'statistics';
    };

    const activePage = getActivePage(location.pathname);

    useEffect(() => {
        const stored = localStorage.getItem('userInfo');
        if (stored) setUserInfo(JSON.parse(stored));

        const checkSwitchPage = () => {
            const target = localStorage.getItem('switchPage');
            if (target) {
                const routes = {
                    'statistics': '/dashboard',
                    'ns': '/ns',
                    'devices': '/devices',
                    'reports': '/reports',
                    'map': '/map',
                    'analysis': '/analysis',
                    'mainsettings': '/mainsettings',
                    'admin': '/admin',
                };
                navigate(routes[target] || '/dashboard');
                localStorage.removeItem('switchPage');
            }
        };

        window.addEventListener('storage', checkSwitchPage);
        window.addEventListener('switchPageRequest', checkSwitchPage);

        return () => {
            window.removeEventListener('storage', checkSwitchPage);
            window.removeEventListener('switchPageRequest', checkSwitchPage);
        };
    }, [navigate]);

    const handleLogout = () => {
        localStorage.clear();
        window.location.href = '/login';
    };

    const handleMenuSelect = (pageId) => {
        const routes = {
            'statistics': '/dashboard',
            'ns': '/ns',
            'devices': '/devices',
            'reports': '/reports',
            'map': '/map',
            'analysis': '/analysis',
            'mainsettings': '/mainsettings',
            'admin': '/admin'
        };
        navigate(routes[pageId] || '/dashboard');
        setIsSidebarOpen(false);
    };

    // ✅ ИЗМЕНЕНО: обработчик отправки замечаний — запрос на backend → Telegram
    const handleFeedbackSubmit = async (e) => {
        e.preventDefault();
        if (feedbackSending) return;

        setFeedbackSending(true);
        setFeedbackError('');

        try {
            // Тот же подход, что и в LoginPage.jsx
            const API_URL = process.env.NODE_ENV === 'production'
                ? ''
                : 'http://localhost:5022';

            const token = localStorage.getItem('token');

            await axios.post(`${API_URL}/api/feedback`, feedback, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            setFeedbackSent(true);
            setTimeout(() => {
                setIsFeedbackOpen(false);
                setFeedbackSent(false);
                setFeedback({ category: 'Замечание', subject: '', message: '' });
            }, 2000);
        } catch (err) {
            console.error('Ошибка отправки обращения:', err);
            setFeedbackError(
                err.response?.data?.error ||
                err.response?.data?.message ||
                'Не удалось отправить обращение. Попробуйте ещё раз.'
            );
        } finally {
            setFeedbackSending(false);
        }
    };

    // ✅ НОВОЕ: закрытие окна замечаний (блокируем во время отправки)
    const closeFeedbackModal = () => {
        if (feedbackSending) return;
        setIsFeedbackOpen(false);
        setFeedbackError('');
    };

    return (
        <div className="min-h-screen bg-slate-900 flex">
            {isSidebarOpen && (
                <div
                    className="fixed inset-0 bg-black/50 z-40 lg:hidden"
                    onClick={() => setIsSidebarOpen(false)}
                />
            )}
            <Sidebar
                isOpen={isSidebarOpen}
                onClose={() => setIsSidebarOpen(false)}
                activePage={activePage}
                onPageSelect={handleMenuSelect}
                userInfo={userInfo}
                onLogout={handleLogout}
            />
            <div className="flex-1 flex flex-col overflow-hidden">
                <header className="bg-slate-800 border-b border-slate-700 px-4 py-2 flex items-center justify-between sticky top-0 z-30">
                    <div className="flex items-center gap-3">
                        <button
                            onClick={() => setIsSidebarOpen(!isSidebarOpen)}
                            className="lg:hidden text-slate-400 hover:text-white transition p-2 rounded-lg hover:bg-slate-700"
                            aria-label="Открыть меню"
                        >
                            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                            </svg>
                        </button>

                        <div className="hidden sm:flex items-center gap-2 select-none">
                            {/* Эмблема — компактнее: 40px → 32px */}
                            <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-slate-700 to-slate-900 border border-slate-600/80 ring-1 ring-white/5 flex items-center justify-center shadow-md shrink-0">
                                <svg
                                    version="1.0"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 110 110"
                                    preserveAspectRatio="xMidYMid meet"
                                    className="w-6 h-6"
                                >
                                    <g transform="translate(10,95) scale(0.08,-0.08)" fill="#FFFFFF" stroke="none">
                                        <path d="M618 957 c-20 -29 -84 -118 -142 -199 l-105 -148 109 0 109 0 42 55 c23 30 45 55 50 55 5 0 9 -25 9 -55 l0 -55 85 0 85 0 0 200 0 200 -102 0 -103 -1 -37 -52z" />
                                        <path d="M152 508 c-80 -110 -84 -118 -70 -123 7 -2 34 -6 61 -7 l47 -3 -85 -124 c-47 -69 -85 -128 -85 -133 0 -5 48 -7 107 -6 l106 3 92 130 91 130 272 3 271 2 56 76 c31 41 59 82 62 90 4 12 -58 14 -441 14 l-445 0 -39 -52z" />
                                        <path d="M694 331 c-2 -2 -4 -53 -4 -113 l0 -108 85 0 85 0 0 110 c0 61 -3 110 -7 110 -52 4 -156 4 -159 1z" />
                                    </g>
                                </svg>
                            </div>

                            {/* Подпись: название + расшифровка */}
                            <div className="flex flex-col justify-center leading-none">
                                {/* Название — чуть мельче: text-lg → text-base */}
                                <h1 className="flex items-baseline text-base font-extrabold tracking-normal">
                                    <span className="bg-gradient-to-b from-white via-slate-200 to-slate-400 bg-clip-text text-transparent drop-shadow-[0_1px_0_rgba(255,255,255,0.18)] drop-shadow-[0_1px_2px_rgba(0,0,0,0.5)]">
                                        Аксиома
                                    </span>
                                    <span className="mx-0.5 text-slate-500">‑</span>
                                    <span className="bg-gradient-to-b from-white via-slate-200 to-slate-400 bg-clip-text text-transparent drop-shadow-[0_1px_0_rgba(255,255,255,0.18)] drop-shadow-[0_1px_2px_rgba(0,0,0,0.5)]">
                                        КС
                                    </span>
                                </h1>

                                {/* Тонкий синий росчерк */}
                                <span
                                    aria-hidden="true"
                                    className="mt-0.5 h-px w-full bg-gradient-to-r from-blue-400/60 via-slate-600/40 to-transparent"
                                />

                                {/* Слоган */}
                                <span className="mt-0.5 text-[10px] font-semibold uppercase tracking-[0.12em] text-slate-400">
                                    Комплексная система
                                </span>
                            </div>
                        </div>


                    </div>

                    {/* ✅ Группа кнопок справа */}
                    <div className="flex items-center gap-2">
                        {/* Кнопка "Замечания и пожелания" */}
                        <button
                            onClick={() => setIsFeedbackOpen(true)}
                            className="flex items-center gap-2 px-3 py-2 bg-amber-600/20 hover:bg-amber-600/30 text-amber-400 hover:text-amber-300 rounded-lg transition"
                            title="Оставить замечания и пожелания"
                        >
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                            </svg>
                            <span className="hidden sm:inline text-sm font-medium">Замечания</span>
                        </button>

                        {/* Кнопка "О программе" */}
                        <button
                            onClick={() => setIsAboutOpen(true)}
                            className="flex items-center gap-2 px-3 py-2 bg-blue-600/20 hover:bg-blue-600/30 text-blue-400 hover:text-blue-300 rounded-lg transition"
                            title="О программе"
                        >
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                            <span className="hidden sm:inline text-sm font-medium">О программе</span>
                        </button>

                        {/* Кнопка "Выйти" */}
                        <button
                            onClick={handleLogout}
                            className="flex items-center gap-2 px-3 py-2 bg-red-600/20 hover:bg-red-600/30 text-red-400 hover:text-red-300 rounded-lg transition"
                        >
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                            </svg>
                            <span className="hidden sm:inline text-sm font-medium">Выйти</span>
                        </button>
                    </div>
                </header>

                <main className="flex-1 overflow-y-auto p-4 sm:p-6 bg-slate-900">
                    <Outlet />
                </main>
            </div>

            {/* ✅ Модальное окно "Замечания и пожелания" */}
            {isFeedbackOpen && (
                <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
                    <div
                        className="absolute inset-0 bg-black/60 backdrop-blur-sm"
                        onClick={closeFeedbackModal}
                    />
                    <div className="relative bg-slate-800 border border-slate-700 rounded-2xl shadow-2xl w-full max-w-lg max-h-[90vh] overflow-y-auto">
                        <div className="flex items-center justify-between p-5 border-b border-slate-700">
                            <h2 className="text-lg font-semibold text-white flex items-center gap-2">
                                <svg className="w-5 h-5 text-amber-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                                </svg>
                                Замечания и пожелания
                            </h2>
                            <button
                                onClick={closeFeedbackModal}
                                className="text-slate-400 hover:text-white transition p-1 rounded-lg hover:bg-slate-700"
                            >
                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>
                        </div>

                        {feedbackSent ? (
                            <div className="p-8 text-center">
                                <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-green-600/20 flex items-center justify-center">
                                    <svg className="w-8 h-8 text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                    </svg>
                                </div>
                                <p className="text-white font-medium text-lg">Спасибо!</p>
                                <p className="text-slate-400 mt-1">Ваше обращение принято и будет рассмотрено.</p>
                            </div>
                        ) : (
                            <form onSubmit={handleFeedbackSubmit} className="p-5 space-y-4">
                                <div>
                                    <label className="block text-sm font-medium text-slate-300 mb-1">
                                        Тип обращения
                                    </label>
                                    <select
                                        value={feedback.category}
                                        onChange={(e) => setFeedback({ ...feedback, category: e.target.value })}
                                        disabled={feedbackSending}
                                        className="w-full px-3 py-2 bg-slate-700 border border-slate-600 rounded-lg text-white text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:opacity-60"
                                    >
                                        <option value="Замечание">Замечание</option>
                                        <option value="Пожелание">Пожелание</option>
                                        <option value="Ошибка">Сообщение об ошибке</option>
                                        <option value="Предложение">Предложение по улучшению</option>
                                    </select>
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-slate-300 mb-1">
                                        Тема
                                    </label>
                                    <input
                                        type="text"
                                        value={feedback.subject}
                                        onChange={(e) => setFeedback({ ...feedback, subject: e.target.value })}
                                        placeholder="Кратко опишите тему обращения"
                                        required
                                        disabled={feedbackSending}
                                        className="w-full px-3 py-2 bg-slate-700 border border-slate-600 rounded-lg text-white text-sm placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:opacity-60"
                                    />
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-slate-300 mb-1">
                                        Текст обращения
                                    </label>
                                    <textarea
                                        value={feedback.message}
                                        onChange={(e) => setFeedback({ ...feedback, message: e.target.value })}
                                        placeholder="Опишите подробно ваше замечание или пожелание..."
                                        required
                                        rows={5}
                                        disabled={feedbackSending}
                                        className="w-full px-3 py-2 bg-slate-700 border border-slate-600 rounded-lg text-white text-sm placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none disabled:opacity-60"
                                    />
                                </div>

                                {/* ✅ НОВОЕ: вывод ошибки отправки */}
                                {feedbackError && (
                                    <div className="px-3 py-2 bg-red-600/20 border border-red-600/40 rounded-lg text-red-300 text-sm flex items-center">
                                        <svg className="w-4 h-4 mr-2 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                        </svg>
                                        <span>{feedbackError}</span>
                                    </div>
                                )}

                                <div className="flex gap-3 pt-2">
                                    <button
                                        type="submit"
                                        disabled={feedbackSending}
                                        className="flex-1 px-4 py-2.5 bg-amber-600 hover:bg-amber-500 disabled:opacity-60 disabled:cursor-not-allowed text-white font-medium rounded-lg transition text-sm flex items-center justify-center"
                                    >
                                        {feedbackSending ? (
                                            <>
                                                <svg className="animate-spin h-4 w-4 text-white mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                                </svg>
                                                Отправка…
                                            </>
                                        ) : (
                                            'Отправить'
                                        )}
                                    </button>
                                    <button
                                        type="button"
                                        onClick={closeFeedbackModal}
                                        disabled={feedbackSending}
                                        className="px-4 py-2.5 bg-slate-700 hover:bg-slate-600 disabled:opacity-60 disabled:cursor-not-allowed text-slate-300 hover:text-white font-medium rounded-lg transition text-sm"
                                    >
                                        Отмена
                                    </button>
                                </div>
                            </form>
                        )}
                    </div>
                </div>
            )}

            {/* ✅ Модальное окно "О программе" */}
            {isAboutOpen && (
                <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
                    <div
                        className="absolute inset-0 bg-black/60 backdrop-blur-sm"
                        onClick={() => setIsAboutOpen(false)}
                    />
                    <div className="relative bg-slate-800 border border-slate-700 rounded-2xl shadow-2xl w-full max-w-md">
                        <div className="flex items-center justify-between p-5 border-b border-slate-700">
                            <h2 className="text-lg font-semibold text-white flex items-center gap-2">
                                <svg className="w-5 h-5 text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                                О программе
                            </h2>
                            <button
                                onClick={() => setIsAboutOpen(false)}
                                className="text-slate-400 hover:text-white transition p-1 rounded-lg hover:bg-slate-700"
                            >
                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>
                        </div>

                        <div className="p-6">
                            <div className="text-center mb-6">
                                {/* Бренд-блок: эмблема + название + слоган (в стиле шапки) */}
                                <div className="mx-auto mb-4 flex flex-col items-center select-none">
                                    {/* Эмблема */}
                                    <div className="w-24 h-24 rounded-2xl bg-gradient-to-br from-slate-700 to-slate-900 border border-slate-600/80 ring-1 ring-white/5 flex items-center justify-center shadow-lg">
                                        <svg
                                            version="1.0"
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 110 110"
                                            preserveAspectRatio="xMidYMid meet"
                                            className="w-16 h-16"
                                        >
                                            <g transform="translate(10,95) scale(0.08,-0.08)" fill="#FFFFFF" stroke="none">
                                                <path d="M618 957 c-20 -29 -84 -118 -142 -199 l-105 -148 109 0 109 0 42 55 c23 30 45 55 50 55 5 0 9 -25 9 -55 l0 -55 85 0 85 0 0 200 0 200 -102 0 -103 -1 -37 -52z" />
                                                <path d="M152 508 c-80 -110 -84 -118 -70 -123 7 -2 34 -6 61 -7 l47 -3 -85 -124 c-47 -69 -85 -128 -85 -133 0 -5 48 -7 107 -6 l106 3 92 130 91 130 272 3 271 2 56 76 c31 41 59 82 62 90 4 12 -58 14 -441 14 l-445 0 -39 -52z" />
                                                <path d="M694 331 c-2 -2 -4 -53 -4 -113 l0 -108 85 0 85 0 0 110 c0 61 -3 110 -7 110 -52 4 -156 4 -159 1z" />
                                            </g>
                                        </svg>
                                    </div>

                                    {/* Название — «металл» с фаской */}
                                    <h1 className="mt-3 flex items-baseline text-2xl font-extrabold tracking-normal">
                                        <span className="bg-gradient-to-b from-white via-slate-200 to-slate-400 bg-clip-text text-transparent drop-shadow-[0_1px_0_rgba(255,255,255,0.18)] drop-shadow-[0_1px_2px_rgba(0,0,0,0.5)]">
                                            Аксиома
                                        </span>
                                        <span className="mx-1 text-slate-500">‑</span>
                                        <span className="bg-gradient-to-b from-white via-slate-200 to-slate-400 bg-clip-text text-transparent drop-shadow-[0_1px_0_rgba(255,255,255,0.18)] drop-shadow-[0_1px_2px_rgba(0,0,0,0.5)]">
                                            КС
                                        </span>
                                    </h1>

                                    {/* Симметричный синий росчерк под центрированным текстом */}
                                    <span
                                        aria-hidden="true"
                                        className="mt-2 h-px w-40 bg-gradient-to-r from-transparent via-blue-400/60 to-transparent"
                                    />

                                    {/* Слоган */}
                                    <span className="mt-2 text-[11px] font-semibold uppercase tracking-[0.2em] text-slate-400">
                                        Комплексная система
                                    </span>
                                </div>

                                {/* Организация */}
                                <h3 className="text-white font-bold text-lg">Группа предприятий Аксиома</h3>
                                <p className="text-blue-400 font-medium text-sm mt-1">ООО «НПО Автоматика-Сервис»</p>
                            </div>

                            <div className="space-y-3 bg-slate-700/50 rounded-xl p-4">
                                <div className="flex items-start gap-3">
                                    <svg className="w-4 h-4 text-slate-400 mt-0.5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                                    </svg>
                                    <span className="text-slate-300 text-sm">
                                        Челябинская обл., г. Златоуст,<br />
                                        Парковый проезд, 3, 456208
                                    </span>
                                </div>

                                <div className="flex items-center gap-3">
                                    <svg className="w-4 h-4 text-slate-400 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                                    </svg>
                                    <a href="tel:+79507354208" className="text-blue-400 hover:text-blue-300 text-sm transition">
                                        +7 (950) 735-42-08
                                    </a>
                                </div>

                                <div className="flex items-center gap-3">
                                    <svg className="w-4 h-4 text-slate-400 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                                    </svg>
                                    <div className="flex flex-col">
                                        <a href="mailto:trubinva@inbox.ru" className="text-blue-400 hover:text-blue-300 text-sm transition">
                                            trubinva@inbox.ru
                                        </a>
                                        <a href="mailto:aquacity@list.ru" className="text-blue-400 hover:text-blue-300 text-sm transition">
                                            aquacity@list.ru
                                        </a>
                                    </div>
                                </div>

                                {/* Сайт */}
                                <div className="flex items-center gap-3">
                                    <svg className="w-4 h-4 text-slate-400 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                    </svg>
                                    <a
                                        href="https://ak74.org"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-blue-400 hover:text-blue-300 text-sm transition"
                                    >
                                        ak74.org
                                    </a>
                                </div>
                            </div>

                            <button
                                onClick={() => setIsAboutOpen(false)}
                                className="w-full mt-5 px-4 py-2.5 bg-slate-700 hover:bg-slate-600 text-slate-300 hover:text-white font-medium rounded-lg transition text-sm"
                            >
                                Закрыть
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Dashboard;